module.exports = __webpack_public_path__ + "img/9791158882426.e0cb65d5.jpg";